import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import CompanyAdditionalFields from "../../models/company-additional-fields";

export interface AdditionalFieldsState {
  loaded: boolean;
  loading: boolean;
  additionalFields: CompanyAdditionalFields | null;
}

const initialState: AdditionalFieldsState = {
  loaded: false,
  loading: true,
  additionalFields: null,
};

export const companyAdditionalFieldsSlice = createSlice({
  name: "additionalFields",
  initialState,
  reducers: {
    setAdditionalFieldsLoading: (state, action: PayloadAction<boolean>) => {
      state.loading = action.payload;
    },
    setAdditionalFields: (
      state,
      action: PayloadAction<CompanyAdditionalFields | null>
    ) => {
      state.additionalFields = action.payload;
      state.loading = false;
    },
  },
});

export const { setAdditionalFieldsLoading, setAdditionalFields } =
  companyAdditionalFieldsSlice.actions;

export default companyAdditionalFieldsSlice.reducer;
